<template>
  <div class="etr">
    <!-- {{ search }} -->
    <!-- <br /><br />
    {{ item }}<br /><br /> -->
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="center" no-gutters>
          <b-col cols="8">
            <b-button-group>
              <b-button
                v-print="'#paper'"
                squared
                size="sm"
                class="mr-4"
                title="Print"
              >
                <i class="fa fa-print pr-3"></i>Print
              </b-button>
              <div class="inline-block" align-v="center">
                <i class="fa fa-suitcase fa-2x mr-1 text-primary"></i>

                <span class="h4 ml-1">{{ item.passenger }}</span>
              </div>
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="busy" rounded="sm">
          <div id="paper" class="mb-3 p-5 background-white text-secondary">
            <div>
              <b-row class="border-bottom-primary background-primary-light" no-gutters align-v="center">
                <b-col cols="auto" class="logo ml-3">
                  <div class="logo-img">
                    <b-img class src="/img/brand/logo_trans.png"></b-img>
                  </div>
                </b-col>
                <b-col class="text-center large uppercase strong">
                  <div class="background-primary-light text-primary p-1">
                    <div class="font-2x">TRAVEL PLACES ITINERARY</div>

                    <div class="font-2x">
                      {{ item.datestart | moment("dddd, DD MMMM YYYY") }} -
                      {{ item.dateend | moment("dddd, DD MMMM YYYY") }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div class="my-4 font-2x">
                <b-row>
                  <b-col cols="2">Event: </b-col>
                  <b-col
                    ><strong>
                      {{ item.eventname }} ( {{ item.eventcode }} )
                    </strong></b-col
                  >
                </b-row>
                <b-row>
                  <b-col cols="2">Company: </b-col>
                  <b-col
                    ><strong>
                      {{ item.clientname }} ( {{ item.slac }} )
                    </strong></b-col
                  >
                </b-row>
                <b-row>
                  <b-col cols="2">Name: </b-col>
                  <b-col
                    ><strong> {{ item.passenger }}</strong>
                  </b-col>
                </b-row>
              </div>

              <div v-if="item" class="large">
                <div v-for="(day, dindex) in item.itinerary" :key="dindex">
                  <div class="text-primary font-3x my-2">
                    {{ day.datetravel | moment("dddd, DD MMMM YYYY") }}
                  </div>

                  <div v-for="(flight, findex) in day.flights" :key="findex">
                    <div
                      class="border-bottom-primary text-primary font-2x my-2"
                    >
                      <i class="fa fa-plane text-primary"></i> Your flights
                    </div>
                    <table class="w-100pct border-none invoicetable">
                      <tr>
                        <td>
                          <div class="text-muted">Departure Date:</div>
                          <div class="font-2x strong">
                            {{ flight.departuredate }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Departure Airport:</div>
                          <div class="font-2x strong">
                            {{ flight.departureairport }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Flight No:</div>
                          <div class="font-2x strong">
                            {{ flight.flightno }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Departure Terminal:</div>
                          <div class="font-2x strong">
                            {{ flight.departureterminal }}
                          </div>
                        </td>
                      </tr>
                      <tr class="spacer">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="text-muted">Arrival Date:</div>
                          <div class="font-2x strong">
                            {{ flight.arrivaldate }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Arrival Airport:</div>
                          <div class="font-2x strong">
                            {{ flight.arrivalairport }}
                          </div>
                        </td>

                        <td>
                          <div class="text-muted">Arrival Terminal:</div>
                          <div class="font-2x strong">
                            {{ flight.arrivalterminal }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Class Name:</div>
                          <div class="font-2x strong">
                            {{ flight.classname }}
                          </div>
                        </td>
                      </tr>
                      <tr class="spacer">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          <div class="text-muted">Bags:</div>
                          <div class="font-2x strong">{{ flight.bags }}</div>
                        </td>
                        <td>
                          <div class="text-muted">Duration:</div>
                          <div class="font-2x strong">
                            {{ flight.duration }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Aircraft:</div>
                          <div class="font-2x strong">
                            {{ flight.aircraft }}
                          </div>
                        </td>
                        <td>
                          <div class="text-muted">Ticket No:</div>
                          <div class="font-2x strong">
                            {{ flight.ticketno }}
                          </div>
                        </td>
                      </tr>
                    </table>
                    <!--    {{ flight }} -->
                  </div>
                  <div v-for="(car, cindex) in day.cars" :key="cindex">
                    <div
                      class="border-bottom-primary text-primary font-2x my-2"
                    >
                      <i class="fa fa-car text-primary"></i> Your cars
                      {{ car }}
                    </div>
                  </div>

                  <div v-for="(hotel, hindex) in day.hotels" :key="hindex">
                    <div
                      class="border-bottom-primary text-primary font-2x my-2"
                    >
                      <i class="fa fa-bed text-primary"></i> Your hotels
                      {{ hotel }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "ItineraryView",
  data() {
    return {
      busy: false,
      id: null,
      item: {
        items: [],
      },
      name: null,
    };
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query itineraries($id: String) {
              itineraries(id: $id) {
                id
                eventcode
                eventname
                slac
                clientname
                passenger
                datestart
                dateend
                days
                itinerary {
                  datetravel
                  flights {
                    ticketno
                    flightno
                    departureterminal
                    departuredate
                    departureairport
                    arrivalairport
                    arrivaldate
                    arrivalterminal
                    classname
                    bags
                    duration
                    aircraft
                  }
                }
              }
            }
          `,
          variables,
        });

        if (response.data.itineraries.length > 0) {
          this.item = response.data.itineraries[0];
        }
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;
      let variables = {
        source: this.search.source,
        datestatement: this.search.datestatement,
        statementtype: this.search.statementtype
          ? this.search.statementtype.join(",")
          : null,
        slac: this.search.selected.slac,
        documentformat: "STM_1",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
          query PNR_Statement(
              $locator: String
           
            ) {
              PNR_Statement(
                locator: $locator              
              ) {               
               version
               datereceived
               locator
               agent
               taxes
               fees
               costtotal
               items
             
                }
              }
            }
          `,
          variables,
        });
        if (response.data.statements.length > 0) {
          let byteCharacters = atob(response.data.statements[0].documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(
            blob,
            "stm_" +
              response.data.statements[0].slac +
              "_" +
              this.$moment().format("_YYYYDDMMHHMMSS") +
              ".pdf"
          );
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>

<style>
.invoicetable {
  font-size: 0.8em;
}
.invoicetable tfoot tr {
  font-size: 1em;
}
</style>
